import { styled, TableBody, TableBodyProps } from "@mui/material";

export const TableTitle = styled(TableBody)<TableBodyProps>(({ theme }) => ({
  "&>tr>td": {
    fontWeight: theme.typography.fontWeightBold,
    paddingTop: theme.spacing(2),
    backgroundColor: "inherit !important",
  },
}));
